module.exports = __webpack_public_path__ + "img/rewards.4380ac2b.webp";